/*
 * Ported from mstreetinvest@cec8be916:resources/js/components/charts/chart-theme.ts (PORTING.md §1.3: "as is —
 * tokens only"). Two values read the console's chat tokens instead of mStreet's: the tooltip's corner is
 * --chat-radius (each console theme owns it; Ledger's is mStreet's 2px) and its lift --chat-shadow-md (mStreet's
 * slate --shadow-md under Ledger), both from app/(admin)/admin-theme.css §1b.
 */
import type { CSSProperties } from 'react';

/**
 * Shared Recharts styling for the boxy, high-contrast design system.
 * Every colour resolves to a CSS token, so light and dark mode follow the theme.
 */

/** Series palette in order of use: blue, teal, amber, violet, neutral. */
export const CHART_COLORS = [
    'var(--chart-1)',
    'var(--chart-2)',
    'var(--chart-3)',
    'var(--chart-4)',
    'var(--chart-5)',
] as const;

/** Opacity of the flat fill under an area series (the stroke carries the colour). */
export const AREA_FILL_OPACITY = 0.12;

/** Horizontal grid lines only, in the border colour. */
export const chartGridProps = {
    vertical: false,
    stroke: 'var(--border)',
} as const;

/** Axes without axis or tick lines; 12px muted tick labels. */
export const chartAxisProps = {
    axisLine: false,
    tickLine: false,
    tick: { fontSize: 12, fill: 'var(--muted-foreground)' },
} as const;

const tooltipContentStyle: CSSProperties = {
    backgroundColor: 'var(--popover)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--chat-radius)',
    boxShadow: 'var(--chat-shadow-md)',
    color: 'var(--popover-foreground)',
    fontSize: 12,
    padding: '6px 10px',
};

/** Boxy tooltip: popover surface, 1px border, overlay shadow, 12px text. */
export const chartTooltipProps = {
    contentStyle: tooltipContentStyle,
    labelStyle: { color: 'var(--popover-foreground)', fontWeight: 500 },
    itemStyle: {
        color: 'var(--popover-foreground)',
        paddingTop: 2,
        paddingBottom: 0,
    },
    cursor: { fill: 'var(--muted)', stroke: 'var(--border)' },
} as const;

/** Legend with 8px square swatches and 12px labels. */
export const chartLegendProps = {
    iconType: 'square',
    iconSize: 8,
    wrapperStyle: { fontSize: 12 },
} as const;

/** Line series: 2px stroke, no point markers except the hovered one. */
export const chartLineProps = {
    strokeWidth: 2,
    dot: false,
    activeDot: { r: 4, strokeWidth: 0 },
} as const;
